import { apiFetch } from "../../http";
export async function deleteExpenseFact(params) {
    const { baseUrl, travelPlanId, expenseId, token, csrfToken } = params;
    return apiFetch(`/travel/api/expense_fact_deleted/${travelPlanId}/${expenseId}/`, {
        baseUrl,
        token,
        method: "DELETE",
        headers: csrfToken ? { "X-CSRFToken": csrfToken } : undefined
    });
}
export async function deleteExpensePlan(params) {
    const { baseUrl, travelPlanId, expenseId, token, csrfToken } = params;
    return apiFetch(`/travel/api/expense_plan_deleted/${travelPlanId}/${expenseId}/`, {
        baseUrl,
        token,
        method: "DELETE",
        headers: csrfToken ? { "X-CSRFToken": csrfToken } : undefined
    });
}
export async function deleteExchangeResult(params) {
    const { baseUrl, travelPlanId, exchangeId, token, csrfToken } = params;
    return apiFetch(`/travel/api/currency_exchange_deleted/${travelPlanId}/${exchangeId}/`, {
        baseUrl,
        token,
        method: "DELETE",
        headers: csrfToken ? { "X-CSRFToken": csrfToken } : undefined
    });
}
export async function getTravelFinance(params) {
    const { baseUrl, travelPlanId, userId, token } = params;
    const query = userId ? `?user_id=${userId}` : "";
    return apiFetch(`/travel/api/get_travel_finance/${travelPlanId}/${query}`, {
        baseUrl,
        token,
        method: "GET"
    });
}
export async function getTravelFinanceCharts(params) {
    const { baseUrl, travelPlanId, userId, token } = params;
    const query = userId ? `?user_id=${userId}` : "";
    return apiFetch(`/travel/api/get_travel_finance_charts/${travelPlanId}/${query}`, {
        baseUrl,
        token,
        method: "GET"
    });
}
export async function getTravelpayoutsExpenseFactsPreview(params) {
    const { baseUrl, travelPlanId, itemTravelId, token } = params;
    const query = itemTravelId !== undefined && itemTravelId !== null
        ? `?item_travel_id=${encodeURIComponent(String(itemTravelId))}`
        : "";
    return apiFetch(`/travel/api/travel_finance/${travelPlanId}/travelpayouts-expense-facts/preview/${query}`, { baseUrl, token, method: "GET", cache: "no-store" });
}
export async function applyTravelpayoutsExpenseFacts(params) {
    const { baseUrl, travelPlanId, updates, token, csrfToken } = params;
    return apiFetch(`/travel/api/travel_finance/${travelPlanId}/travelpayouts-expense-facts/apply/`, {
        baseUrl,
        token,
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            ...(csrfToken ? { "X-CSRFToken": csrfToken } : {})
        },
        body: JSON.stringify({ updates })
    });
}
